import $ from 'jquery';
import { parseInt } from 'lodash';
export default function customJS(context) { 
    
        
    const { graphql_token, currency_selector, hide_ask_an_expert, hide_recently_viewed_popup, hide_instagram, ig_access_token, ig_access_token_1, ig_access_token_2, ig_access_token_3, enable_recently_bougth_popup, enable_recently_bougth_popup_mobile, rb_popup_text, rb_popup_info, rb_popup_hours, rb_popup_productid, rb_popup_city_country_1, rb_popup_city_country_2, rb_popup_city_country_3, rb_popup_city_country_4, rb_popup_city_country_5, rb_popup_city_country_6, rb_popup_city_country_7, rb_popup_city_country_8, rb_popup_city_country_9, rb_popup_city_country_10, rbp_product_switch, recently_viewed_expires_date, recently_viewed_product_limit, productId} = context;
    const active_currency_id = currency_selector.active_currency_id;
    const active_currency_code = currency_selector.active_currency_code;
    const customUrl = new URL(window.location.href);
    const hiddenRecentlyViewedProductIds = ['182870'];
    const recentlyViewedStorageKey = 'cg_recently_viewed_products';
    const footerRecentlyViewedHistoryLimit = 10;

    const promoAssistantRoot = document.querySelector('[data-promo-assistant]');

    if (promoAssistantRoot) {
        import(/* webpackChunkName: "promo-assistant" */ './global/promo-assistant')
            .then(({ default: initPromoAssistant }) => {
                initPromoAssistant(context);
            })
            .catch(() => {
                // Keep the rest of the storefront interactive if the assistant chunk fails.
            });
    }

    const escapeHtml = (value) => String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    const normalizeProductIds = (productIds = []) => {
        const orderedIds = [];

        productIds.forEach((productId) => {
            const normalizedId = String(productId || '').trim();

            if (!/^\d+$/.test(normalizedId)) {
                return;
            }

            if (hiddenRecentlyViewedProductIds.indexOf(normalizedId) !== -1) {
                return;
            }

            if (orderedIds.indexOf(normalizedId) === -1) {
                orderedIds.push(normalizedId);
            }
        });

        return orderedIds;
    };

    const limitRecentlyViewedProductIds = (productIds = []) => {
        const normalizedProductIds = normalizeProductIds(productIds);

        if (normalizedProductIds.length <= footerRecentlyViewedHistoryLimit) {
            return normalizedProductIds;
        }

        return normalizedProductIds.slice(-footerRecentlyViewedHistoryLimit);
    };

    const readStoredRecentlyViewedProductIds = () => {
        try {
            const storedProductIds = JSON.parse(window.localStorage.getItem(recentlyViewedStorageKey) || '[]');

            return Array.isArray(storedProductIds) ? limitRecentlyViewedProductIds(storedProductIds) : [];
        } catch (error) {
            return [];
        }
    };

    const readCookieRecentlyViewedProductIds = () => {
        const existingCookieValue = getCookie('bc_recently_viewed');

        return existingCookieValue ? limitRecentlyViewedProductIds(existingCookieValue.split(',')) : [];
    };

    const writeStoredRecentlyViewedProductIds = (productIds = []) => {
        try {
            window.localStorage.setItem(recentlyViewedStorageKey, JSON.stringify(limitRecentlyViewedProductIds(productIds)));
        } catch (error) {
            // Keep the cookie path as the fallback if storage is unavailable.
        }
    };

    const writeCookieRecentlyViewedProductIds = (productIds = []) => {
        const cookieProductLimit = Math.min(Number.parseInt(recently_viewed_product_limit, 10) || footerRecentlyViewedHistoryLimit, footerRecentlyViewedHistoryLimit);
        const expireDays = Number.parseInt(recently_viewed_expires_date, 10) || 30;
        const expirationDate = new Date();
        const limitedProductIds = limitRecentlyViewedProductIds(productIds);

        expirationDate.setDate(expirationDate.getDate() + expireDays);
        document.cookie = `bc_recently_viewed=${limitedProductIds.slice(-cookieProductLimit).join(',')};expires=${expirationDate.toGMTString()}; path=/`;
    };

    const persistTrackedRecentlyViewedProduct = () => {
        const currentProductId = String(productId || '').trim();

        if (!/^\d+$/.test(currentProductId) || hiddenRecentlyViewedProductIds.indexOf(currentProductId) !== -1) {
            return;
        }

        const existingStoredProductIds = readStoredRecentlyViewedProductIds();
        const existingCookieProductIds = existingStoredProductIds.length > 0 ? [] : readCookieRecentlyViewedProductIds();
        const combinedProductIds = limitRecentlyViewedProductIds([...existingStoredProductIds, ...existingCookieProductIds]);
        const updatedProductIds = combinedProductIds.filter(savedProductId => savedProductId !== currentProductId);

        updatedProductIds.push(currentProductId);

        if (updatedProductIds.length > footerRecentlyViewedHistoryLimit) {
            updatedProductIds.splice(0, updatedProductIds.length - footerRecentlyViewedHistoryLimit);
        }

        writeStoredRecentlyViewedProductIds(updatedProductIds);
        writeCookieRecentlyViewedProductIds(updatedProductIds);
    };

    const getTrackedRecentlyViewedProductIds = () => {
        const storedProductIds = readStoredRecentlyViewedProductIds();
        const trackedProductIds = storedProductIds.length > 0 ? storedProductIds : readCookieRecentlyViewedProductIds();

        return limitRecentlyViewedProductIds(trackedProductIds);
    };

    const fetchRecentlyViewedProducts = (productIds, imageWidth = 220) => {
        const normalizedProductIds = normalizeProductIds(productIds);

        if (normalizedProductIds.length === 0) {
            return Promise.resolve(null);
        }

        if (graphql_token === '' || graphql_token === 'undefined') {
            return Promise.resolve(null);
        }

        return fetch(`/graphql?setCurrencyId=${active_currency_id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${graphql_token}`,
            },
            body: JSON.stringify({
                query: `query RecentlyViewedProducts {
                    site {
                        currency(currencyCode: ${active_currency_code}) {
                            display {
                                symbol
                            }
                        }
                        products(entityIds: [${normalizedProductIds.join(',')}]) {
                            edges {
                                node {
                                    entityId
                                    name
                                    sku
                                    path
                                    defaultImage {
                                        url(width:${imageWidth})
                                        altText
                                    }
                                    addToCartUrl
                                    productOptions {
                                        edges {
                                            node {
                                                displayName
                                            }
                                        }
                                    }
                                    prices {
                                        basePrice {
                                            value
                                        }
                                        salePrice {
                                            value
                                        }
                                        priceRange {
                                            min {
                                                value
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }`,
            }),
        }).then(res => res.json()).catch(() => null);
    };

    const orderProductsByIds = (productIds, productEdges = []) => {
        const productMap = new Map();

        productEdges.forEach((productEdge) => {
            const product = productEdge?.node;

            if (!product) {
                return;
            }

            productMap.set(String(product.entityId), product);
        });

        return normalizeProductIds(productIds)
            .map(productId => productMap.get(String(productId)))
            .filter(Boolean);
    };

    const buildProductPriceMarkup = (product, symbol) => {
        const basePrice = product?.prices?.basePrice?.value;
        const salePrice = product?.prices?.salePrice?.value;
        const minRangePrice = product?.prices?.priceRange?.min?.value;
        const displayPrice = typeof minRangePrice === 'number'
            ? minRangePrice
            : (typeof salePrice === 'number' && salePrice !== null ? salePrice : basePrice);

        if (typeof displayPrice !== 'number') {
            return '';
        }

        return `<div class="card-price-line"><span class="card-price-prefix">From</span><span class="price price--card-from">${symbol}${displayPrice.toFixed(2)}</span></div>`;
    };

    const buildFooterRecentlyViewedCard = (product, symbol) => {
        const entityId = escapeHtml(String(product.entityId || ''));
        const path = escapeHtml(product.path || '#');
        const name = escapeHtml(product.name || '');
        const imageUrl = escapeHtml(product.defaultImage?.url || '');
        const imageAlt = escapeHtml(product.defaultImage?.altText || product.name || '');
        const priceMarkup = buildProductPriceMarkup(product, symbol);
        const imageMarkup = imageUrl ? `<img class="card-image" src="${imageUrl}" alt="${imageAlt}" loading="lazy">` : '';

        return `<div class="footer-recently-viewed__slide" data-product-id="${entityId}">
            <article class="card new-card card-figure footer-recently-viewed__card" data-test="card-${entityId}" attr-cards-ids="${entityId}">
                <figure class="card-figure featured-imag">
                    <a href="${path}">
                        <div class="card-img-container">
                            ${imageMarkup}
                        </div>
                    </a>
                </figure>
                <div class="card-body">
                    <h3 class="card-title">
                        <a href="${path}">${name}</a>
                    </h3>
                    <div class="card-text myprice" data-test-info-type="price">
                        ${priceMarkup}
                    </div>
                    <div class="card-cta">
                        <a href="${path}" class="button button--primary button--small card-cta-button">
                            View Details
                        </a>
                    </div>
                </div>
            </article>
        </div>`;
    };

    const updateFooterRecentlyViewedControls = ($track, $content) => {
        const track = $track.get(0);

        if (!track) {
            return;
        }

        const canScroll = track.scrollWidth > track.clientWidth + 4;
        const atStart = track.scrollLeft <= 4;
        const atEnd = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth - 4;

        $content.find('.footer-recently-viewed__actions').toggleClass('is-hidden', !canScroll);
        $content.find('.footer-recently-viewed__arrow--prev').prop('disabled', !canScroll || atStart);
        $content.find('.footer-recently-viewed__arrow--next').prop('disabled', !canScroll || atEnd);
    };

    const bindFooterRecentlyViewedControls = ($content) => {
        const $track = $content.find('[data-footer-recently-viewed-track]');

        if ($track.length === 0) {
            return;
        }

        const trackElement = $track.get(0);

        const scrollTrack = (direction) => {
            const track = trackElement;

            if (!track) {
                return;
            }

            const scrollAmount = Math.max(track.clientWidth * 0.82, 280);
            track.scrollBy({
                left: direction * scrollAmount,
                behavior: 'smooth',
            });
        };

        const bindTouchDrag = () => {
            if (!trackElement) {
                return;
            }

            const existingHandlers = trackElement.footerRecentlyViewedTouchHandlers;

            if (existingHandlers) {
                trackElement.removeEventListener('touchstart', existingHandlers.onTouchStart);
                trackElement.removeEventListener('touchmove', existingHandlers.onTouchMove);
                trackElement.removeEventListener('touchend', existingHandlers.onTouchEnd);
                trackElement.removeEventListener('touchcancel', existingHandlers.onTouchEnd);
                trackElement.removeEventListener('click', existingHandlers.onClickCapture, true);
            }

            let startX = 0;
            let startY = 0;
            let startScrollLeft = 0;
            let isPointerDown = false;
            let isDragging = false;
            let shouldHandleDrag = false;
            let suppressClick = false;
            const dragThreshold = 10;

            const getTouchPoint = (event) => event.touches && event.touches.length
                ? event.touches[0]
                : null;

            const onTouchStart = (event) => {
                const point = getTouchPoint(event);

                if (!point) {
                    return;
                }

                isPointerDown = true;
                isDragging = false;
                shouldHandleDrag = false;
                startX = point.pageX;
                startY = point.pageY;
                startScrollLeft = trackElement.scrollLeft;
                trackElement.classList.remove('is-dragging');
            };

            const onTouchMove = (event) => {
                if (!isPointerDown) {
                    return;
                }

                const point = getTouchPoint(event);

                if (!point) {
                    return;
                }

                const deltaX = point.pageX - startX;
                const deltaY = point.pageY - startY;

                if (!shouldHandleDrag) {
                    if (Math.abs(deltaX) < dragThreshold && Math.abs(deltaY) < dragThreshold) {
                        return;
                    }

                    shouldHandleDrag = Math.abs(deltaX) > Math.abs(deltaY);

                    if (!shouldHandleDrag) {
                        isPointerDown = false;

                        return;
                    }
                }

                isDragging = true;
                suppressClick = true;
                trackElement.classList.add('is-dragging');
                trackElement.scrollLeft = startScrollLeft - deltaX;

                if (event.cancelable) {
                    event.preventDefault();
                }
            };

            const onTouchEnd = () => {
                if (!isPointerDown && !isDragging) {
                    return;
                }

                isPointerDown = false;
                shouldHandleDrag = false;

                if (isDragging) {
                    trackElement.classList.remove('is-dragging');
                    window.setTimeout(() => {
                        suppressClick = false;
                    }, 140);
                } else {
                    suppressClick = false;
                }

                isDragging = false;
            };

            const onClickCapture = (event) => {
                if (!suppressClick) {
                    return;
                }

                event.preventDefault();
                event.stopPropagation();
            };

            trackElement.addEventListener('touchstart', onTouchStart, { passive: true });
            trackElement.addEventListener('touchmove', onTouchMove, { passive: false });
            trackElement.addEventListener('touchend', onTouchEnd, { passive: true });
            trackElement.addEventListener('touchcancel', onTouchEnd, { passive: true });
            trackElement.addEventListener('click', onClickCapture, true);

            trackElement.footerRecentlyViewedTouchHandlers = {
                onTouchStart,
                onTouchMove,
                onTouchEnd,
                onClickCapture,
            };
        };

        $content.off('click.footerRecentlyViewed');
        $content.on('click.footerRecentlyViewed', '.footer-recently-viewed__arrow--prev', () => {
            scrollTrack(-1);
        });
        $content.on('click.footerRecentlyViewed', '.footer-recently-viewed__arrow--next', () => {
            scrollTrack(1);
        });

        $track.off('scroll.footerRecentlyViewed');
        $track.on('scroll.footerRecentlyViewed', () => {
            updateFooterRecentlyViewedControls($track, $content);
        });

        $(window).off('resize.footerRecentlyViewed');
        $(window).on('resize.footerRecentlyViewed', () => {
            updateFooterRecentlyViewedControls($track, $content);
        });

        bindTouchDrag();
        updateFooterRecentlyViewedControls($track, $content);
    };

    const initFooterRecentlyViewed = () => {
        const $section = $('[data-footer-recently-viewed-section]');
        const $content = $('[data-footer-recently-viewed]');
        const productIds = getTrackedRecentlyViewedProductIds();

        if ($section.length === 0 || $content.length === 0 || productIds.length === 0) {
            return;
        }

        fetchRecentlyViewedProducts(productIds, 320).then((res) => {
            if (!res?.data?.site) {
                return;
            }

            const symbol = res.data.site.currency.display.symbol;
            const products = orderProductsByIds(productIds, res.data.site.products.edges);

            if (products.length === 0) {
                return;
            }

            let footerRecentlyViewedHtml = `<div class="footer-recently-viewed__track" data-footer-recently-viewed-track tabindex="0" aria-label="Products you previously viewed">
                ${products.map(product => buildFooterRecentlyViewedCard(product, symbol)).join('')}
            </div>`;

            if (products.length > 1) {
                footerRecentlyViewedHtml += `<div class="footer-recently-viewed__actions">
                    <button type="button" aria-label="Scroll to previous previously viewed products" class="footer-recently-viewed__arrow footer-recently-viewed__arrow--prev">
                        <svg width="38px" height="26px"><use xlink:href="#arrow-left"></use></svg>
                    </button>
                    <button type="button" aria-label="Scroll to next previously viewed products" class="footer-recently-viewed__arrow footer-recently-viewed__arrow--next">
                        <svg width="38px" height="26px"><use xlink:href="#arrow-right"></use></svg>
                    </button>
                </div>`;
            }

            $content.html(footerRecentlyViewedHtml);
            $section.show();
            bindFooterRecentlyViewedControls($content);
        });
    };

    persistTrackedRecentlyViewedProduct();
    initFooterRecentlyViewed();

    
    



    //hide_recently_viewed_popup start
    if(hide_recently_viewed_popup){
        const productIds = getTrackedRecentlyViewedProductIds();

        if(productIds.length > 0) {
            fetchRecentlyViewedProducts(productIds, 100).then((res) => {
                if(res?.data?.site != null){
                    const productsGq = orderProductsByIds(productIds, res.data.site.products.edges);
                    const symbol = res.data.site.currency.display.symbol;
                    let rv_html = ``;

                    productsGq.length > 0 && productsGq.map((obj) => {
                        const entityId = obj.entityId;
                        const path = obj.path;
                        const name = obj.name;
                        const productOptions = obj.productOptions.edges;
                        const defaultImage = obj.defaultImage?.url;
                        const addToCartUrl = obj.addToCartUrl;

                        let addToCartUrl_html = "";
                        if(productOptions.length > 0){
                            addToCartUrl_html += `<a href="${path}">Choose Options</a>`;
                        }else{
                            addToCartUrl_html += `<a href="${addToCartUrl}">Add to Cart</a>`;
                        }

                        rv_html += `<div class="rv-card-slides"><div class="rv-card" data-id="${entityId}">
                        <div class="rv-card-inner">
                            <div class="rv-product-section">
                                <h4 class="rv-title"><a href="${path}">${name}</a></h4>
                                <div class="rv-price">${buildProductPriceMarkup(obj, symbol)}</div>
                                <p class="rv-action">${addToCartUrl_html}</p>
                            </div>
                            <div class="rv-image-section">
                                <a href="${path}"><img class="rv-card-image" src="${defaultImage}" alt="${name}" width="auto" height="auto" /></a>
                            </div>
                        </div>
                    </div></div>`;                        
                    });

                    $(".rv-in-porduct .rv-product-list").html(rv_html);

                    if(productIds.length >= 4){
                        $(".rv-in-porduct .rv-product-list").addClass('is-slider');
                        $(".rv-in-porduct .rv-product-list").slick({
                            infinite: false,
                            vertical: true,
                            verticalSwiping: true,
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            prevArrow: `<svg class="prev-icon" width="30" height="20" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="chevron-up" role="img" viewBox="0 0 448 512" class="svg-inline--fa fa-chevron-up fa-w-14 fa-2x"><path fill="currentColor" d="M4.465 366.475l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L224 178.053l195.494 195.493c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-211.05-211.051c-4.686-4.686-12.284-4.686-16.971 0L4.465 349.505c-4.687 4.686-4.687 12.284 0 16.97z" class=""/></svg>`,
                            nextArrow: `<svg class="next-icon" width="30" height="20" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="chevron-down" role="img" viewBox="0 0 448 512" class="svg-inline--fa fa-chevron-down fa-w-14 fa-2x"><path fill="currentColor" d="M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z" class=""/></svg>`
                        });
                    }

                    $(".sidebar-recently-collapse").addClass('is-active');
                }
            });
        }else{
            $(".sidebar-recently-view .rv-in-porduct .rv-no-product").show();
            $(".rv-in-porduct .rv-product-list").remove();
            $(".sidebar-recently-view").addClass('is-active');
        }

        //Icon Click to Hide Sliderbar
        $(".sidebar-recently-view").on('click', '.collapse-icon', function(){
            $(".sidebar-recently-view").removeClass('is-active');
            $(".sidebar-recently-collapse").addClass('is-active');
        });
        //Icon Click to Hide Sliderbar
        $(".sidebar-recently-collapse .iconEx").on('click', function(){
            $(".sidebar-recently-collapse").removeClass('is-active');
            $(".sidebar-recently-view").addClass('is-active');
        });

        if(document.cookie.indexOf('bc_recently_viewed') <= 0) { 
            $(".sidebar-recently-view .collapse-icon").addClass('d-none');
            $(".sidebar-recently-view .rv-cart").addClass('d-none');
            $(".sidebar-recently-view .rv-in-porduct").addClass('d-none');
            $(".sidebar-recently-view").addClass('remove_shadow');
        }else{
            $(".sidebar-recently-view .collapse-icon").removeClass('d-none');
            $(".sidebar-recently-view .rv-cart").removeClass('d-none');
            $(".sidebar-recently-view .rv-in-porduct").removeClass('d-none');
            $(".sidebar-recently-view").removeClass('remove_shadow');
        }

    } 
    //hide_recently_viewed_popup end

    // Add To Wish List   
    // -----------------------------------------------------------------------------
    $(document).on('click', '.card .wishlist', (e) => {
        e.preventDefault();
        var $this_wl = $(e.currentTarget);
        var url_awl = $this_wl.attr('href');

        if ($('body').hasClass('customer-is-login')) {
            $.post(url_awl).done(function() {
                window.location.href = url_awl;
            });
        }
        else {
            window.location.href = '/login.php';
        }
    });


    //Instagram Feed - Start

    if(hide_instagram && $(".home_instagram_feed_main").length > 0){
        if(ig_access_token != ""){
        const url = "https://graph.instagram.com/me/media?fields=id,media_type,media_url,permalink,username,timestamp&access_token="+ig_access_token+ig_access_token_1+ig_access_token_2+ig_access_token_3+"&limit=20";
        $.ajax({
            url:url,
            type:'GET',
            dataType:'json',
            success: function(res){
                const feed = res.data;
                if(feed.length > 0){
                    var html = "";
                    html += `<div class="IGFeeds">`;
                    for (let i = 0; i < feed.length; i++){
                        const media_type = feed[i].media_type;
                        const media_url = feed[i].media_url;
                        const permalink = feed[i].permalink;
                        if(media_type != "VIDEO"){
                            html += `<ul>`;
                            html += `<li class="IGFeed">`;
                            html += `<a class="IGFeed_link" href="${permalink}">`;
                                html += `<img src="${media_url}" alt="Image">`
                                html += `<div class="IGFees_hover">`;
                                    html += `<div>`;
                                        html += `<span class="IG_icon"><svg><use xlink:href="#icon-instagram"></use></svg></span>`;
                                        html += `<button class="button" href="${permalink}" onclick="window.open(this.getAttribute('href')); return false;">Shop the Look</button>`;
                                    html += `</div>`;
                                html += `</div>`;
                            html += `</a>`;
                            html += `</li>`;
                            html += `</ul>`;
                        }
                    }
                    html += `</div>`;
                    html += `<div class="all-btn recent-post">                
                    <button class="js-product-prev-arrow-insta slick-prev slick-arrow" aria-label="slick-prev"><svg width="38px" height="26px"><use xlink:href="#arrow-left"></use></svg></button>
                    <button class="js-product-next-arrow-insta slick-next slick-arrow" aria-label="slick-next"><svg width="38px" height="26px"><use xlink:href="#arrow-right"></use></svg></button>            
                </div>`;
                    $('#instafeed').append(html);
                    const feed_box = $('#instafeed .IGFeed').length;
                    if(feed_box > 6){
                        $('#instafeed .IGFeeds').slick({
                            prevArrow: ".js-product-prev-arrow-insta",
                            nextArrow: ".js-product-next-arrow-insta",
                            dots: false,
                            arrows: true,
                            infinite: true,
                            speed: 500,
                            slidesToShow: 6,
                            slidesToScroll: 6,
                            responsive: 
                            [
                                {breakpoint: 1350,settings: {slidesToShow: 5,slidesToScroll: 5}},
                                {breakpoint: 1200,settings: {slidesToShow: 4,slidesToScroll: 4}},
                                {breakpoint: 992,settings: {slidesToShow: 3,slidesToScroll: 3}},
                                {breakpoint: 601,settings: {slidesToShow: 2,slidesToScroll: 2}},
                                {breakpoint: 451,settings: {slidesToShow: 1,slidesToScroll: 1}}
                            ] 
                        });
                    }
                }
            }
        });
        }
    }
    //Instagram Feed - End


    //Recently bougth Products - Start
const recently_bougth_popup = (status) => {
    if (document.cookie.indexOf('bc_recently_bougth') === -1) {
        if (status && enable_recently_bougth_popup) {
            const rb_text = rb_popup_text;
            const rb_info = rb_popup_info;
            const rb_switch_time = 1000 * Number(rbp_product_switch);
            const rb_productID = JSON.parse("[" + rb_popup_productid + "]");
            const rb_hours = JSON.parse("[" + rb_popup_hours + "]");
            const city_country_1 = rb_popup_city_country_1;
            const city_country_2 = rb_popup_city_country_2;
            const city_country_3 = rb_popup_city_country_3;
            const city_country_4 = rb_popup_city_country_4;
            const city_country_5 = rb_popup_city_country_5;
            const city_country_6 = rb_popup_city_country_6;
            const city_country_7 = rb_popup_city_country_7;
            const city_country_8 = rb_popup_city_country_8;
            const city_country_9 = rb_popup_city_country_9;
            const city_country_10 = rb_popup_city_country_10;
            const cc_city_country_arr = [city_country_1, city_country_2, city_country_3, city_country_4, city_country_5, city_country_6, city_country_7, city_country_8, city_country_9, city_country_10];
            fetch("/graphql", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + graphql_token },
                body: JSON.stringify({
                    query: `
                        query RecentlyBougthProducts { 
                            site {
                                products(entityIds: [${rb_productID}] ) {
                                    edges {
                                        node {
                                            entityId
                                            name
                                            path
                                            defaultImage {
                                                url(width: 320)
                                            }
                                            inventory {
                                                aggregated {
                                                  availableToSell
                                                  warningLevel
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `
                }),
            })
                .then(res => res.json())
                .then((res) => {
                    const prod_length = res.data.site.products.edges;
                    if (prod_length.length > 0) {
                        var html = "";
                        html += `<div class="RB_Items">`;
                        for (let p = 0; p < prod_length.length; p++) {
                            const common_random = Math.floor(Math.random() * rb_hours.length);
                            const currentCity = cc_city_country_arr[common_random];
                            const currentHours = rb_hours[common_random];
                            const entityId = prod_length[p].node.entityId;
                            const p_name = prod_length[p].node.name;
                            const p_path = prod_length[p].node.path;
                            const defaultImage = prod_length[p].node.defaultImage;
                            // const availableToSell = prod_length[p].node.inventory.aggregated.availableToSell;
                            const imageNull = "https://dummyimage.com/320x320/ccc/000000.jpg&text=Coming+Soon";
                            html += `<div id="RB_` + entityId + `" class="RB_Item" style="display:none; left:-500px;">`;
                            html += `<a href="javascript:void(0)" class="RB_close_btn"><svg class="icon"><use xlink:href="#icon-close"></svg></a>`;
                            html += `<div class="RB_inner">`;
                            html += `<a href="` + p_path + `">`;
                            if (defaultImage == null) {
                                html += `<img src="` + imageNull + `" />`;
                            } else {
                                html += `<img src="` + defaultImage.url + `" />`;
                            }
                            html += `</a>`;
                            html += `<div class="RB_product_info">`;
                            html += `<p class="text_wrap"><span class="text">` + rb_text + `</span><span class="rb_product_name"><a href="` + p_path + `">` + p_name + `</a></span>`;
                            html += `</p>`;
                            html += `<div class="location_info">` + currentHours + " " + rb_info + " " + currentCity + `</div>`;
                            // Show product stock information
                            // html += `<div class="product_stock">Only ${availableToSell} remain</div>`;
                            html += `</div>`;
                            html += `</div>`;
                            html += `</div>`;
                        }
                        html += `</div>`;
                        $('#recentlyBougthProducts').html(html);
                    }
                    setInterval(function () {
                        const animateLoop = Math.floor(Math.random() * rb_productID.length);
                        setTimeout(function () {
                            $('#recentlyBougthProducts .RB_Items .RB_Item').fadeOut('slow').css("left", "-500px");
                        }, rb_switch_time - 1500);
                        $('#recentlyBougthProducts .RB_Items #RB_' + rb_productID[animateLoop]).show().css("left", "0");
                    }, rb_switch_time);
                    $('body').on('click', '.RB_close_btn', function () {
                        $("#recentlyBougthProducts").remove();
                        const date = new Date();
                        date.setDate(date.getDate() + 1);
                        document.cookie = `bc_recently_bougth=Close;expires=${date.toGMTString()}; path=/`;
                    });
                });
        }
    }
}
if (enable_recently_bougth_popup_mobile == false && window.innerWidth < 992) {
    recently_bougth_popup(false);
} else if (enable_recently_bougth_popup_mobile == true && window.innerWidth < 992) {
    recently_bougth_popup(true);
} else {
    recently_bougth_popup(true);
}
    //Recently bougth Products - Start

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
        }
        return "";
    }

    $(window).scroll(function(){
        if($(window).scrollTop() > 200){
            $(".sidebar-recently-view .rv-cart").attr('style','border-bottom:1px solid #ccc;');
            $(".sidebar-recently-view .rv-cart, .sidebar-recently-view .rv-top").css('height','40px');
            
        }else{
            $(".sidebar-recently-view .rv-cart, .sidebar-recently-view .rv-top").css('height','0');
            $(".sidebar-recently-view .rv-cart").attr('style','border-bottom:none;');
        }
    });
    
    
    $(".rv-top, .sidebar-recently-collapse .iconTop").click(function() {
        $("html, body").animate({ scrollTop: 0 }, 2000);
        return false;
    });

}
